<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted(){
		
  },
  methods:{
    
  }
}
</script>

<style lang="scss">
@import './base/style/common.scss';
html,body{
	height: 100%;
}	
#app {
	height: 100%;
  font-family: "microsoft yahei",'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

}
</style>



// WEBPACK FOOTER //
// src/App.vue